import { Controller } from 'stimulus';

import RailsApi from '../models/rails-api';

export default class extends Controller {
  static targets = ['banner'];

  bannerTarget: HTMLElement;

  dismissBanner() {
    void RailsApi.post('/app/savings_overview_downturn_message_dismissal');
    this.bannerTarget.classList.add('u-displayNone');
  }
}
